export default function validate(values: any, t: any) {
  let errors = {
    email: "",
    phone: "",
    project_name: "",
    agreement: "",
    category: "",
    url: "",
  };
  if (!values.email) {
    errors.email = t("signup__empty_email_error");
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = t("signup__invalid_email_error");
  }
  if (!values.project_name) {
    errors.project_name = t("signup__project_name_error");
  }
  if (!values.phone) {
    errors.phone = t("signup__empty_phone_error");
  } else if (
    // eslint-disable-next-line
    !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(
      values.phone
    )
  ) {
    errors.phone = t("signup__invalid_phone_error");
  }
  if (!values.category) {
    errors.category = t("signup__category_error");
  }
  if (values.agreement === false) {
    errors.agreement = t("signup__agreement_error");
  }

  return errors;
}
